import type { TFunction } from 'i18next'
import type { VirtualIpVoiceCandidate, VirtualIpVoiceCandidateStatus } from '../../api'
import { downloadCanvasMedia } from '../contentProduction/canvas/canvasDownload'

export type CandidatePlaybackUiState = 'pending' | 'ready' | 'failed' | 'no_audio'

export function resolveCandidatePlaybackUiState(candidate: VirtualIpVoiceCandidate): CandidatePlaybackUiState {
  const status = candidate.status as VirtualIpVoiceCandidateStatus
  if (status === 'PENDING' || status === 'GENERATING') return 'pending'
  if (status === 'FAILED') return 'failed'
  if (status === 'READY' || status === 'SELECTED') {
    return candidate.audio?.playback_url ? 'ready' : 'no_audio'
  }
  return candidate.audio?.playback_url ? 'ready' : 'no_audio'
}

export function isVoiceCandidateSelectable(candidate: VirtualIpVoiceCandidate): boolean {
  return resolveCandidatePlaybackUiState(candidate) === 'ready'
}

/** Native navigation download — avoids cross-origin fetch/blob (Preview CORS). */
export function downloadVoiceCandidateAudio(playbackUrl: string): void {
  if (!playbackUrl) return
  downloadCanvasMedia(playbackUrl)
}

export function formatVoiceGenerateError(
  err: { code?: string; message?: string; status?: number },
  t: TFunction<'virtualIp'>,
): string {
  const code = err.code || ''
  if (code === 'voice_capability_not_ready') {
    return err.message || t('step6.errors.capabilityNotReady')
  }
  if (code === 'VOICE_DESIGN_FAILED' || code === 'no_candidates') {
    return err.message || t('step6.errors.designFailed')
  }
  if (code === 'AUTH_ERROR' || code === 'not_authenticated' || code === 'invalid_session') {
    return t('step6.errors.authExpired')
  }
  if (code === 'RATE_LIMITED') {
    return t('step6.errors.rateLimited')
  }
  if (code === 'STORAGE_FAILED') {
    return t('step6.errors.storageFailed')
  }
  if (err.status === 503) {
    return err.message || t('step6.errors.capabilityNotReady')
  }
  if (err.message && !/network error/i.test(err.message)) {
    return err.message
  }
  return t('step6.errors.networkFailed')
}
